module.exports = __webpack_public_path__ + "assets/img/2_838.20aba235.jpg";